/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccE2eFixtureResetDocument } from './PccE2eFixtureResetDocument';
import {
    PccE2eFixtureResetDocumentFromJSON,
    PccE2eFixtureResetDocumentFromJSONTyped,
    PccE2eFixtureResetDocumentToJSON,
} from './PccE2eFixtureResetDocument';

/**
 * 
 * @export
 * @interface PccE2eFixtureResetDocumentsByExactTuplesRequest
 */
export interface PccE2eFixtureResetDocumentsByExactTuplesRequest {
    /**
     * 
     * @type {string}
     * @memberof PccE2eFixtureResetDocumentsByExactTuplesRequest
     */
    mode: PccE2eFixtureResetDocumentsByExactTuplesRequestModeEnum;
    /**
     * 
     * @type {Array<PccE2eFixtureResetDocument>}
     * @memberof PccE2eFixtureResetDocumentsByExactTuplesRequest
     */
    documents: Array<PccE2eFixtureResetDocument>;
}


/**
 * @export
 */
export const PccE2eFixtureResetDocumentsByExactTuplesRequestModeEnum = {
    Documents: 'documents'
} as const;
export type PccE2eFixtureResetDocumentsByExactTuplesRequestModeEnum = typeof PccE2eFixtureResetDocumentsByExactTuplesRequestModeEnum[keyof typeof PccE2eFixtureResetDocumentsByExactTuplesRequestModeEnum];


/**
 * Check if a given object implements the PccE2eFixtureResetDocumentsByExactTuplesRequest interface.
 */
export function instanceOfPccE2eFixtureResetDocumentsByExactTuplesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mode" in value;
    isInstance = isInstance && "documents" in value;

    return isInstance;
}

export function PccE2eFixtureResetDocumentsByExactTuplesRequestFromJSON(json: any): PccE2eFixtureResetDocumentsByExactTuplesRequest {
    return PccE2eFixtureResetDocumentsByExactTuplesRequestFromJSONTyped(json, false);
}

export function PccE2eFixtureResetDocumentsByExactTuplesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetDocumentsByExactTuplesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mode': json['mode'],
        'documents': ((json['documents'] as Array<any>).map(PccE2eFixtureResetDocumentFromJSON)),
    };
}

export function PccE2eFixtureResetDocumentsByExactTuplesRequestToJSON(value?: PccE2eFixtureResetDocumentsByExactTuplesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mode': value.mode,
        'documents': ((value.documents as Array<any>).map(PccE2eFixtureResetDocumentToJSON)),
    };
}

